const productNavLinks = document.querySelectorAll('.product-nav__link');

// Scroll to Section
productNavLinks.forEach(link => {
  link.addEventListener('click', function(e) {
    const headerHeigt = parseInt(getComputedStyle(document.querySelector('.mega-sticky-header')).height);
    const productNavHeight = parseInt(getComputedStyle(document.querySelector('.sticky-product-nav')).height);
    const relatedSection = document.getElementById(link.getAttribute('data-section'));
    const topOffset = headerHeigt + productNavHeight;

    e.preventDefault();

    if (!relatedSection) return;
    document.body.scrollTop = relatedSection.offsetTop - topOffset;
    document.documentElement.scrollTop = relatedSection.offsetTop - topOffset;
  })
})


// Active section on Scroll
const productNavSections = [...productNavLinks].map(link => document.getElementById(link.getAttribute('data-section')));

window.addEventListener('scroll', function() {
  const headerHeigt = parseInt(getComputedStyle(document.querySelector('.mega-sticky-header')).height);
  const productNavHeight = parseInt(getComputedStyle(document.querySelector('.sticky-product-nav')).height);
  const topOffset = headerHeigt + productNavHeight;

  productNavSections.forEach(section => {
    if (section.getAttribute('id') === 'main-product') return;
    const sectionTopOffset = section.offsetTop - topOffset;
    const sectionHeight = parseInt(getComputedStyle(section).height);
    const sectionBottomOffset = sectionTopOffset + sectionHeight;
    const relatedNavLink = document.querySelector(`.product-nav__link[data-section=${section.getAttribute('id')}]`);

    if (Math.ceil(window.pageYOffset) >= sectionTopOffset && Math.ceil(window.pageYOffset) <= sectionBottomOffset) {
      relatedNavLink.classList.add('active');
    } else {
      relatedNavLink.classList.remove('active');
    }
  })
})